const PartnersGroup = {
  MAIN_PARTNER: "main",
  OTHER_PARTNERS: "other",
};

export default PartnersGroup;
